/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import dayjs from "dayjs";
import Config from "data/config";

// Function to format date and time
export const formatDateTime = (dataRow, fieldType) => {
    if (fieldType === "date") {
        const dateValue = dataRow?.date;
        if (dateValue) {
            const parseFormat = Config.dates.internalFormats.date;
            const displayFormat = Config.dates.display.date_american;
            const date = dayjs(dateValue, parseFormat);
            return date.format(displayFormat);
        }
        return "N/A";
    } else if (fieldType === "time") {
        const timeValue = dataRow?.time;
        if (timeValue) {
            const parseFormat = Config.dates.internalFormats.time;
            const displayFormat = Config.dates.display.time;
            const time = dayjs(timeValue, parseFormat);
            return time.format(displayFormat);
        }
        return "N/A";
    } else if (fieldType === "datetime") {
        const datetimeValue = dataRow?.time;
        if (datetimeValue) {
            const parseFormat = Config.dates.internalFormats.datetime;
            const displayFormat = Config.dates.display.datetime;
            const datetime = dayjs(datetimeValue, parseFormat);
            return datetime.format(displayFormat);
        }
        return "N/A";
    }
    return dataRow?.[fieldType] || "N/A";
};

// Function to format date and time
// const formatDateTime = (dataRow, fieldType) => {
//     if (fieldType === "date") {
//         const dateValue = dataRow?.created_at;
//         if (dateValue) {
//             const date = new Date(dateValue);
//             return date.toLocaleDateString("en-CA"); // YYYY-MM-DD format
//         }
//         return dataRow?.date || "N/A";
//     } else if (fieldType === "time") {
//         const timeValue = dataRow?.time;
//         if (timeValue) {
//             // If it's already a time string like "13:00:00" or "01:00:00", parse it
//             if (typeof timeValue === "string" && timeValue.includes(":")) {
//                 const timeParts = timeValue.split(":");
//                 if (timeParts.length >= 2) {
//                     const hours = parseInt(timeParts[0], 10);
//                     const minutes = parseInt(timeParts[1], 10);
//
//                     // Validate hours and minutes
//                     if (!isNaN(hours) && !isNaN(minutes) && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
//                         const period = hours >= 12 ? "PM" : "AM";
//                         const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
//                         return `${hour12.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${period}`;
//                     }
//                 }
//             }
//             // If it's a valid date object or timestamp, format it
//             const date = new Date(timeValue);
//             if (!isNaN(date.getTime())) {
//                 const timeString = date.toLocaleTimeString("en-US", {
//                     hour: "2-digit",
//                     minute: "2-digit",
//                     hour12: true
//                 });
//                 return timeString.replace(/a\.m\./gi, "AM").replace(/p\.m\./gi, "PM").replace(/am/gi, "AM").replace(/pm/gi, "PM");
//             }
//         }
//         return "N/A";
//     }
//     return dataRow?.[fieldType] || "N/A";
// };

